import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { UserSharedService } from '../core/users/user.service';


@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
    constructor(private userService: UserSharedService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const requiredPermission = route.data['permission'] as string;

        if (this.userService.hasSchoolPermission(requiredPermission)) {
            return true;
        }
        // Redirect to unauthorized page or home
        return this.router.parseUrl('/auth/access');
    }
}